import { lazy } from 'react';

const CHUNK_RELOAD_FLAG = 'crm-chunk-reload';

export function isChunkLoadError(error) {
  const message = error?.message ?? String(error ?? '');
  return /Failed to fetch dynamically imported module|Loading chunk [\d]+ failed|error loading dynamically imported module/i.test(message);
}

export function reloadOnceForStaleChunk() {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_FLAG)) return false;
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
    window.location.reload();
    return true;
  } catch {
    window.location.reload();
    return true;
  }
}

export function clearChunkReloadFlag() {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
  } catch {
    /* ignore */
  }
}

export function lazyImport(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (isChunkLoadError(error) && reloadOnceForStaleChunk()) {
        return new Promise(() => {});
      }
      clearChunkReloadFlag();
      throw error;
    })
  );
}
